export const purposeDataEnum = {
	AD: 'ad',
	AD_ANALYTICS: 'adAnalytics',
	ANALYTICS: 'analytics',
	FUNCTIONALITY: 'functionality',
	PERSONALIZATION: 'personalization',
	SECURITY: 'security',
};

export const FRAGMENTS = {
	ACCORDION_BTN: '[data-fragment="cp.accordionBtn"]',
	ACCEPT_ALL_BTN: '[data-fragment="cp.acceptAllBtn"]',
	CLOSE_BTN: '[data-fragment="cp.closeBtn"]',
	JSON_DATA: '[data-fragment="cp.jsonData"]',
	OPEN_SETTINGS_BTN: '[data-fragment="cp.openSettingsBtn"]',
	OPEN_SETTINGS_LINK: '[data-fragment="cp.openSettingsLink"]',
	PANE: '[data-fragment="cp.pane"]',
	SETTINGS: '[data-fragment="cp.settings"]',
	SETTINGS_ACCEPT_ALL_BTN: '[data-fragment="cp.settingsAcceptAllBtn"]',
	SETTINGS_ACCEPT_SELECTED_BTN: '[data-fragment="cp.settingsAcceptSelectedBtn"]',
	SETTINGS_CLOSE_BTN: '[data-fragment="cp.settingsCloseBtn"]',
	SETTINGS_PURPOSE_INPUT: '[data-fragment="cp.settingsPurposeInput"]',
	SETTINGS_RECIPIENT_INPUT: '[data-fragment="cp.settingsRecipientInput"]',
	SETTINGS_STATE_TEXT: '[data-fragment="cp.settingsStateText"]',
	SETTINGS_TECHNICAL_BTN: '[data-fragment="cp.settingsTechnicalBtn"]',
	TAB_BTN: '[data-fragment="cp.tabBtn"]',
	TECHNICAL_BTN: '[data-fragment="cp.technicalBtn"]',
};

export const LEVEL = {
	CONFIG: 1, // uzivatel videl panel a chce nastavit uroven
	TECHNICAL: 2, // uz. souhlasi s technickymi cookies (min uroven po ulozeni nastaveni)
	ANALYTICS: 3, // uz. souhlasi s technickymi A analytickymi cookies (nepouzito)
	AD: 4, // uz. souhlasi s technickymi A marketingovymi cookies
	AD_ANALYTICS: 5, // uz. souhlasi s technickymi A analytickymi A marketingovymi cookies
	FUNCTIONALITY: 6,
	PERSONALIZATION: 7,
	SECURITY: 8,
};

export const COOKIE_NAME = {
	DEFAULT: 'fg_cookie_policy_accepted',
	RECIPIENT: 'fg_cookie_policy_accepted',
};



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/CookiesPolicy4/enums/enums.js